import * as React from 'react';
import './complete-add-event-modal.scss';
import Button from '../../../common/button/button';
import { useNavigate } from 'react-router-dom';

interface Props {
    onClose: Function;
}

const CompleteAddEventModal: React.FC<Props> = ({ onClose }) => {
    const navigate = useNavigate();

    const onCloseModal = () => {
        onClose(false);
        navigate(`/calendar`);
    };

    return (
        <div className="complete-add-event-modal-background">
            <div className="complete-add-event-modal">
                <div className="complete-add-event-modal__head">추가완료</div>
                <div className="complete-add-event-modal__subhead">캘린더가 추가되었습니다.</div>
                <div className="complete-add-event-modal__button">
                    <Button label="확인" type="type2" action={onCloseModal} />
                </div>
            </div>
        </div>
    );
};
export default CompleteAddEventModal;
